<template>
	<div>
		<base-loader v-if="fetching" loader-message="Loading Courses"></base-loader>
		<template v-if="!fetching">
			<table class="w-full table">
				<thead>
					<tr>
						<th>Name</th>
						<th>Address</th>
					</tr>
				</thead>
				<tbody>
					<course-list-item
						:key="`course-item-${i}`"
						v-for="(course, i) in courses"
						:golf-course="course"
						@course-updated="courseUpdated"
					></course-list-item>
				</tbody>
			</table>
		</template>
	</div>
</template>
<script>
/** @format */
import courses from './../modules/courses'

export default {
	name: 'BaseCourseList',
	methods: {
		courseUpdated(course) {
			this.courses = this.courses.map(c => {
				if (c.uuid === course.uuid) {
					c = course;
				}
				return c;
			});
		},
		refresh() {
			try {
				this.fetching = true;
				courses.getAll(true).then(courseList => {
					this.courses = courseList;
					this.fetching = false;
					this.$emit('loaded');
				})
			} catch(e) {
				console.error(e)
			}
			
		}
	},
	components: {
		'course-list-item': () => import(/* webpackChunkName: "CourseListItem" */ './Course/ListItem')
	},
	mounted() {
		this.refresh();
	},
	data() {
		return {
			courses: [],
			fetching: true
		};
	}
};
</script>
